import qs from 'qs'

export default function ({$axios, store, app, redirect, $config, $cookies}) {

  $axios.onRequest(config => {
    const gaHeader = {};
    let gaId = $cookies.get('_ga')?.split('.');
    if (gaId?.length) {
      gaId = gaId[gaId.length - 2] + '.' + gaId[gaId.length - 1];
      gaHeader['ga-client-id'] = gaId;
    }
    const fbpHeader = $cookies.get('_fbp') ? {fbp: $cookies.get('_fbp')} : {};
    // config.baseURL += '/uk'
    config.baseURL = $config.API_URL;
    if ($config.DEVSKIPORIGINCHECK_KEY) {
      config.headers['DEVSKIPORIGINCHECK'] = $config.DEVSKIPORIGINCHECK_KEY;
    }
    return {
      ...config,
      paramsSerializer: params => qs.stringify(params, {arrayFormat: 'brackets'}),
      headers: {
        ...config.headers,
        // 'Accept-Language': 'en',
        'Accept-Language': app.i18n.locale,
        // 'X_USER_UUID': app.store.getters.getUserUUID
        ...gaHeader,
        ...fbpHeader
      },
      params: {
        ...config.params
      }
    }
  })

  $axios.onResponse(response => {
    // console.log('response', response);
    if (response && response.data) {
      let res = {
        ...response,
        data: response.data
      }
      if(res.data && res.data.error_code) {
        switch (res.data.error_code) {
          case 404: {
            // redirect('/404');
            break;
          }
          case 403: {
            // redirect('/404');
            break;
          }
          case 503: {
            //make a page for this
            redirect('/404');
            break;
          }
          case 401: {
            store.dispatch('removeUserInfo', null);
            redirect('/');
            break;
          }
        }
      }
      return res
    }
    // console.log('response', res);

  })

  $axios.onError(({response}) => {
    // console.log('error res', response);
   if (response && response.data) {
     if (response.status === 404) {
       // redirect('/404');
     }
     if (response.status === 403) {
       // redirect('/403');
     }
     if (response.status === 503) {
       // redirect('/maintenance');
     }
     if (response.status === 401) {
       store.dispatch('removeUserInfo', null);
       redirect('/');
     }
   }
    // return Promise.reject(response)
  })
}
